var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"paragraph"}})],1):_c('div',[_c('Apexchart',{attrs:{"type":"radar","options":_vm.chartOptions,"series":_vm.series}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }